import { ChevronFirst, LogOutIcon } from "lucide-react";
import { CompanyLogo } from "../../../../Components/Utils";
import { useContext, useEffect } from "react";
import { AdminContext } from "../AdminLayout";
import { useUser } from "../../../../contexts/UserContext";
import Cookies from "js-cookie";
import { ToastMessage } from "../../../../Components/Utils";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../constants/routeConstants";
import Img from "../../../User/components/Img";
import { user_profile_image_url } from "../../../../Components/ImageUrls";
const SideBar = ({ children }) => {
    const { expanded, setExpanded, isMobile, setIsMobile, dark } = useContext(AdminContext);
    const { user, setUser } = useUser();
    const navigate = useNavigate();
    console.log()
    const handleLogout = () => {
        Cookies.remove('token');
        setUser(null);
        ToastMessage({
            type: 'success',
            message: 'Logged out successfully',
            title: 'Goodbye!'
        });
        navigate(ROUTE_PATHS.LOGIN);
    };
    const defaultAvatar = `https://ui-avatars.com/api/?name=${encodeURIComponent((user?.name || "User").split(" ").slice(0, 2).join("+"))}&background=F97316&color=fff&size=128`;
    const displayAvatar = user?.user_image ? `${user_profile_image_url}${user.user_image}` : defaultAvatar;
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [setIsMobile]);

    useEffect(() => {
        if (isMobile) {
            setExpanded(false);
        } else {
            setExpanded(true);
        }
    }, [setExpanded, isMobile]);
    return <>
        <aside
            className={`
                h-screen
                shrink-0
                ${expanded ? "w-64" : "w-20"}
                transition-all duration-300
            `}
        >
            <nav className="h-full flex flex-col bg-white border-r border-gray-200 shadow-sm dark:bg-slate-950 dark:border-gray-700">
                <div className={`p-4 pb-2 flex justify-${expanded ? "between" : "center"} items-center`}>
                    <CompanyLogo className={`overflow-hidden transition-all h-12 ${expanded ? "w-32" : "hidden"}`} dark={dark} />
                    <button onClick={() => setExpanded(curr => !curr)} className="p-1.5 center rounded-lg bg-gray-50 hover:bg-orange-100 hover:text-orange-600 dark:bg-slate-800 dark:hover:bg-orange-500/20 dark:hover:text-orange-200">
                        {expanded ? <ChevronFirst size={20} /> : <ChevronFirst size={20} className="rotate-180" />}
                    </button>
                </div>
                {/* Side bar Data */}
                <ul
                    className="
                    flex-1
                    min-h-0
                    px-2
                    py-3
                    space-y-1
                    overflow-y-auto
                    overflow-x-visible
                    custom-scrollbar
                "
                >
                    {children}
                </ul>
                {/* Sidebar Footer */}
                <div className="border-t border-gray-200 flex p-3 mt-auto dark:border-gray-700">
                    <Img
                        src={displayAvatar}
                        className="w-10 h-10 rounded-md shadow-md border-2 border-green-400 dark:border-green-700"
                        alt="User avatar"
                    />
                    <div className={`flex justify-between items-center overflow-hidden transition-all ${expanded ? "w-52 ml-3" : "w-0"}`}>
                        <div className="leading-4 text-start">
                            <h4 className="font-semibold text-gray-900 dark:text-gray-100 truncate max-w-[180px]">{user?.name || 'User'}</h4>
                            <span className="text-xs text-gray-600 dark:text-gray-400 truncate max-w-[180px]">{user?.email || 'user@example.com'}</span>
                        </div>
                        <div className="relative">
                            <LogOutIcon
                                size={20}
                                className="text-gray-500 p-2 dark:text-gray-300 cursor-pointer hover:text-gray-700 dark:hover:text-gray-200 p-1 rounded hover:bg-gray-100 dark:hover:bg-slate-700 transition-all"
                                onClick={(e) => {
                                    handleLogout();
                                }}
                            />
                            <span className="absolute right-0 top-8 bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100">
                                Logout
                            </span>
                        </div>
                    </div>
                </div>
            </nav>
        </aside>

    </>
}

export default SideBar;
